import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { reduxForm, change } from 'redux-form';

import { BlueButton, WhiteButton } from 'libs/ui';
import { Buttons, Container, ErrorMsg, StyledField, Title } from './bsk-form.styled';

export const required = (t) => (value) => {
  return value || value === 0 ? undefined : t('required.Обязательное поле');
};

class BskForm extends React.Component {
  constructor(props) {
    super(props);
    this.requiredValidator = required(props.t);
    this.state = {
      catd: props.card,
    };
  }

  addEvent = (msg) => {
    if (this._mounted && msg.source === this.props.id && msg.data && msg.data.method === 'card.read') {
      this.setState({ card: msg.data.card_id });
      this.props.dispatch(change(this.props.form, 'mean_id', msg.data.card_id));
    }
  };

  componentDidMount() {
    this._mounted = true;
    window.socket.on('add_event', this.addEvent);
  }

  componentWillUnmount() {
    this._mounted = false;
    window.socket.off('add_event', this.addEvent);
  }

  fillList = (type) => {
    const object = window.config[type];
    let item;
    return Object.keys(object).map((el, idx) => {
      item = object[el];
      return (
        <option key={idx} value={el}>
          {item}
        </option>
      );
    });
  };

  getCategoriesList = () => {
    return this.fillList('vehicle_category_map');
  };

  getClassesList = () => {
    return this.fillList('vehicle_class_map');
  };

  render() {
    const { handleSubmit, loading, t } = this.props;
    //console.log('🚀 ~ render ~ this.props', this.props);

    let vehicle_category_def;
    if (this.props.categories && this.props.categories.length) {
      vehicle_category_def = this.props.categories[0].id;
    }

    let err = '';
    if (this.props.errors && this.props.errors.type) {
      if (this.props.errors.type === 'duplicate') {
        err += ' ' + t('messages.БСК с таким номером уже существует');
      }
    }

    return (
      <Container>
        <Title>{t('windows.Выдать БСК')}</Title>
        <form onSubmit={handleSubmit}>
          {err !== '' && (
            <ErrorMsg>
              <img src="/images/error-triangle-icon.png" alt="" />
              {t('messages.Ошибка')} {err}
            </ErrorMsg>
          )}

          <StyledField type="select" label={t('windows.Статус')} name="is_blocked">
            <option value={false}>{t('clarifications.Активен')}</option>
            <option value={true}>{t('clarifications.Заблокирован')}</option>
          </StyledField>

          <StyledField type="text" label={t('windows.БСК')} placeholder="3786 4678 6467 5656" name="mean_id" validate={this.requiredValidator} />
          <StyledField
            type="text"
            label={t('windows.Держатель')}
            placeholder={t('windows.Введите текст')}
            name="owner"
            validate={this.requiredValidator}
          />

          <StyledField validate={this.requiredValidator} type="select" label={t('windows.Класс ТС')} name="vehicle_class">
            <option value={-1}>{t('clarifications.Не задано')}</option>
            {this.getClassesList()}
          </StyledField>
          <StyledField type="select" label={t('windows.Категория')} name="vehicle_category" value={vehicle_category_def}>
            <option value={-1}>{t('clarifications.Не задано')}</option>
            {this.getCategoriesList()}
          </StyledField>

          <StyledField
            type="date"
            label={t('windows.Дата действия по')}
            placeholder={t('windows.Дата действия по')}
            name="end_at"
            //validate={required}
          />

          <StyledField
            type="text"
            label={t('windows.Комментарий')}
            placeholder={t('windows.Введите текст')}
            name="comment"
            //validate={required}
          />

          <Buttons>
            <WhiteButton onClick={() => this.props.close()}>{t('buttons.Отменить')}</WhiteButton>
            <BlueButton className={loading ? 'loading' : ''} type="submit">
              {t('buttons.Сохранить')}
            </BlueButton>
          </Buttons>
        </form>
      </Container>
    );
  }
}

BskForm.propTypes = {
  close: PropTypes.func.isRequired,
};

const d1 = moment().subtract(1, 'days');

export default withTranslation()(
  reduxForm({
    form: 'bsk',
    initialValues: { end_at: d1 },
    onSubmit: (data, dispatch, props) => {
      return props.action(data);
    },
    onSubmitSuccess(result, dispatch, props) {
      dispatch(props.reset());
    },
  })(BskForm)
);
